<template>
  <div class="admin">
    <LoginPage></LoginPage>
  </div>
</template>

<script>
import LoginPage from '@/components/LoginPage.vue';

export default {
  name: 'adminView',
  components: {
    LoginPage
  }
}
</script>
